import { joinClassnames } from 'helpers/classNames';
import React from 'react';
import KickImage from 'Reuseables/KickImage';

import { IArrowProps } from './Arrow.definitions';

/** CSS import */
import Styles from './Arrow.module.scss';

import ArrowLeft from 'images/arrow-left-chevron.png';
import ArrowRight from 'images/arrow-right-chevron.png';

const Arrow: React.FC<IArrowProps> = ({ type, onClick, show }: IArrowProps) => {
  const typeClasses = React.useMemo(() => {
    if (type === 'right') {
      return Styles['right'];
    }
    return Styles['left'];
  }, [type]);

  const showClasses = React.useMemo(() => {
    if (show) {
      return Styles['show'];
    }
    return Styles['hide'];
  }, [show]);

  const arrowImage = React.useMemo(() => {
    if (type === 'right') {
      return ArrowRight;
    }
    return ArrowLeft;
  }, [type]);

  return (
    <div
      className={joinClassnames(Styles['wrapper'], typeClasses, showClasses)}
      onClick={onClick}
    >
      <KickImage src={arrowImage} className={Styles['img']} />
    </div>
  );
};

export default Arrow;
